import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "list-filter-popover" }
const _hoisted_2 = { class: "list-filter-popover__filter-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_text = _resolveComponent("el-text")!
  const _component_CloseIcon = _resolveComponent("CloseIcon")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, {
      justify: "space-between",
      align: "middle",
      class: "list-filter-popover__header"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_text, {
          type: "info",
          tag: "b"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.filterTitle), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_el_icon, {
          class: "list-filter-popover__close",
          onClick: _ctx.closeFilter
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CloseIcon)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["onClick"])
      ]),
      _: 1 /* STABLE */
    }),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "filter-content")
    ]),
    _createVNode(_component_el_container, { class: "list-filter-popover__button-wrapper" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          plain: "",
          class: "list-filter-popover__button",
          disabled: !_ctx.isFilterActive,
          "data-v-test": "resetFilterButton",
          onClick: _ctx.resetFilter
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.resetButtonTitle), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["disabled", "onClick"]),
        _createVNode(_component_el_button, {
          type: "primary",
          class: "list-filter-popover__button",
          loading: _ctx.isFilterLoading,
          "data-v-test": "submitFilterButton",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.submitFilter($event, _ctx.formRefference)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.submitButtonTitle), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["loading"])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}